var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.980724L0.892353 0L5.75277 5.34495C5.83112 5.43059 5.8933 5.53244 5.93573 5.64462C5.97816 5.7568 6 5.87711 6 5.99861C6 6.12012 5.97816 6.24042 5.93573 6.3526C5.8933 6.46479 5.83112 6.56663 5.75277 6.65227L0.892353 12L0.000840664 11.0193L4.56269 6L0 0.980724Z",
    fill: "#564AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.e8c02f53bd39f099b2658574cfdb40cf.svg";
export { ForwardRef as ReactComponent };